import { Box, Icon, TextInput, TextNew } from '@jfs/ui-new'
import { Passwordreg } from '@jfs/utils'
import { ReactElement, useEffect, useState } from 'react'
import { testProps } from '../../util/util'
import { ModBox } from '../ModifiedBox/ModifiedBox'

const returnRightIcon = (showPassword: boolean, isConfirmPassword: boolean, arePasswordEqual: boolean) => {
  if (arePasswordEqual && isConfirmPassword) {
    return 'SUCCESSFUL_FILLED'
  } else if (showPassword) {
    return 'EYE_WATCH'
  } else if (!showPassword) {
    return 'EYE_WATCH_SELECTED'
  } else {
    return 'EYE_WATCH'
  }
}

const getEyeRightView = (
  showPassword: boolean,
  setShowPassword: (val: boolean) => void,
  fieldValue: string,
  fieldName: string,
  allValues: any,
): ReactElement | null => {
  // alert(password)
  const handleIconPress = (): void => {
    setShowPassword(!showPassword)
  }
  const isConfirmPassword = fieldName === 'passwordConfirm'
  const isPasswordRegexSatisfied = Passwordreg.test(allValues?.passwordConfirm)
  const arePasswordEqual =
    allValues?.password === allValues?.passwordConfirm && allValues?.password?.length > 0 && isPasswordRegexSatisfied
  const markUpGreen = arePasswordEqual && isConfirmPassword
  return (
    <ModBox show={fieldValue?.length > 0} pr={5}>
      <Box onPress={handleIconPress} {...testProps('toggle-pwd-icon')} underlayColor="WHITE">
        <Icon
          id={returnRightIcon(showPassword, isConfirmPassword, arePasswordEqual)}
          color={markUpGreen ? 'GREEN' : 'BLUE'}
          size="FONT_SIZE_LARGE"
        />
      </Box>
    </ModBox>
  )
}

const onChange = (text: string, setFieldValue: (val1: string, val2: string) => void, fieldName: string) => {
  if (setFieldValue && fieldName) {
    setFieldValue(fieldName, text)
  }
}

const onTFBlur = (isConfirmPassword: boolean, setError: (str: string) => void, allValues: any) => {
  if (isConfirmPassword) {
    if (
      allValues?.password !== allValues?.passwordConfirm &&
      allValues?.passwordConfirm?.length > 0 &&
      allValues?.password?.length > 0
    ) {
      setError("Password doesn't match")
    }
  }
}

const onFocus = (setError: (str: string) => void) => {
  setError('')
}

export const PasswordTextInput = ({
  label,
  setFieldValue,
  fieldName,
  autoFocus,
  returnKeyType,
  testID = 'default-id',
  accessibilityLabel = 'text-input',
  allValues,
}: any) => {
  const [showPassword, setShowPassword] = useState(false)
  const [fieldValue, setValue] = useState('')
  const [error, setError] = useState('')
  const [focused, setFocused] = useState(false)
  const isConfirmPassword = fieldName === 'passwordConfirm'

  useEffect(() => {
    // const isPasswordRegexSatisfied = Passwordreg.test(allValues?.password)
    const passwordField = allValues?.password
    const confPasswordField = allValues?.passwordConfirm
    if (
      (passwordField === confPasswordField && passwordField?.length > 0) ||
      passwordField?.length < 1 ||
      confPasswordField?.length < 1
    ) {
      setError('')
    } else if (passwordField !== confPasswordField && passwordField?.length > 0 && confPasswordField?.length > 0) {
      setError("Password doesn't match")
    }
  }, [allValues])
  return (
    <>
      <TextInput
        label={label}
        testID={testID}
        accessibilityLabel={accessibilityLabel}
        autoFocus={autoFocus}
        value={fieldValue}
        onFocusBottomLineColor={'BLUE'}
        textContentType="none"
        onChangeText={(text: string) => [setValue(text), onChange(text, setFieldValue, fieldName)]}
        secureTextEntry={!showPassword}
        returnKeyType={returnKeyType ?? 'next'}
        rightComponent={getEyeRightView(showPassword, setShowPassword, fieldValue, fieldName, allValues)}
        onBlur={() => [setFocused(false), onTFBlur(isConfirmPassword, setError, allValues)]}
        error={error}
        onFocus={() => [onFocus(setError), setFocused(true)]}
      />
      <ModBox show={error !== '' && !focused && isConfirmPassword} pt={10}>
        <TextNew type="body12" color="ERROR" textAlign="left">
          {error}
        </TextNew>
      </ModBox>
    </>
  )
}
